$(function () {
    var $wrapper = $('#global-search');
    if (!$wrapper.length) return;

    var searchUrl = $wrapper.data('search-url');
    var $input = $('#global-search-input');
    var $closeBtn = $('#global-search-close');
    var $suggestions = $('#search-suggestions');

    if (!$input.length || !$suggestions.length) return;

    var debounceTimer = null;
    var activeIndex = -1;

    var CATEGORIES = {
        users:    { label: 'USERS',    icon: '<i class="fas fa-user"></i>' },
        payments: { label: 'PAYMENTS', icon: '<i class="fas fa-credit-card"></i>' },
        payroll:  { label: 'PAYROLL',  icon: '<i class="fas fa-money-check-alt"></i>' },
        invoices: { label: 'INVOICES', icon: '<i class="fas fa-file-invoice-dollar"></i>' },
        tickets:  { label: 'TICKETS',  icon: '<i class="fas fa-ticket-alt"></i>' },
    };

    // ── Helpers ────────────────────────────────────────────────────────

    function activate() {
        $wrapper.addClass('active');
        $input.focus();
    }

    function deactivate() {
        $wrapper.removeClass('active');
        $input.val('');
        $suggestions.html('').hide();
        activeIndex = -1;
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    function highlightItem($items) {
        $items.removeClass('active');
        if (activeIndex >= 0 && $items[activeIndex]) {
            $($items[activeIndex]).addClass('active').scrollIntoView({ block: 'nearest' });
        }
    }

    // ── Render ─────────────────────────────────────────────────────────

    function renderResults(data) {
        var html = '';
        var totalResults = 0;

        $.each(data, function (cat, items) {
            if (!items || !items.length) return;
            totalResults += items.length;

            var category = CATEGORIES[cat] || { label: cat.toUpperCase(), icon: '' };
            html += '<div class="search-category">';
            html += '<div class="search-category-header">' + category.icon + ' ' + category.label + '</div>';

            $.each(items, function (_, item) {
                html += '<a class="search-result-item" href="' + item.url + '" data-url="' + item.url + '">';
                html += '<div class="search-result-name">' + escapeHtml(item.name) + '</div>';
                html += '<div class="search-result-subtitle">' + escapeHtml(item.subtitle || '') + '</div>';
                html += '</a>';
            });

            html += '</div>';
        });

        $suggestions.html(totalResults ? html : '<div class="search-no-results">No results found</div>');
        activeIndex = -1;
    }

    // ── Fetch ──────────────────────────────────────────────────────────

    function fetchResults(query) {
        $suggestions.html('<div class="search-loading">Searching...</div>').show();

        $.ajax({
            url: searchUrl,
            method: 'GET',
            data: { q: query },
            success: function (data) {
                renderResults(data);
            },
            error: function () {
                $suggestions.html('<div class="search-no-results">Something went wrong</div>');
            },
        });
    }

    // ── Events ─────────────────────────────────────────────────────────

    $wrapper.on('click', function () {
        if (!$wrapper.hasClass('active')) activate();
    });

    $input.on('click', function () {
        if (!$wrapper.hasClass('active')) activate();
    });

    $closeBtn.on('click', function () {
        deactivate();
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $wrapper.hasClass('active')) {
            deactivate();
        }
    });

    $input.on('input', function () {
        clearTimeout(debounceTimer);
        var query = $.trim($input.val());

        if (query.length < 2) {
            $suggestions.html('').hide();
            activeIndex = -1;
            return;
        }

        debounceTimer = setTimeout(function () {
            fetchResults(query);
        }, 300);
    });

    $input.on('keydown', function (e) {
        var $items = $suggestions.find('.search-result-item');
        if (!$items.length) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                activeIndex = Math.min(activeIndex + 1, $items.length - 1);
                highlightItem($items);
                break;
            case 'ArrowUp':
                e.preventDefault();
                activeIndex = Math.max(activeIndex - 1, 0);
                highlightItem($items);
                break;
            case 'Enter':
                e.preventDefault();
                if (activeIndex >= 0 && $items[activeIndex]) {
                    window.location.href = $($items[activeIndex]).data('url');
                } else if ($items.length === 1) {
                    window.location.href = $items.first().data('url');
                }
                break;
        }
    });
});
